import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProducts } from './endpoints';
import { useState } from 'react';
export const useProductUpdate = (customerId) => {
    const queryClient = useQueryClient();
    const [statusMessage, setStatusMessage] = useState(null);
    const { mutate: upgradeDowngradeProducts, isLoading, isError, } = useMutation({
        mutationFn: updateProducts,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['customer-products', customerId],
            });
        },
        onError: (error) => {
            var _a;
            return setStatusMessage({
                type: 'error',
                message: (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message,
            });
        },
    });
    return {
        upgradeDowngradeProducts,
        isLoading,
        isError,
        statusMessage,
        clearStatusMessage: () => setStatusMessage(null),
    };
};
